export default __webpack_public_path__ + "static/media/Hack_Banner1280.2356f365.png";